import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';

import FooterButton from './FooterButton';
import SidePanel from './SidePanel';

import update from './update';
import validate from './validate';

import stepTwoIllustration from '/public/SiteImages/step2.svg';

import { url } from '../../config';

import bt from '../../components/commonStyle.css';
import s from './ListPlaceStep1.css';

const FALLBACK_DESCRIPTIONS = {
  entero: 'Los huéspedes disponen del alojamiento completo para ellos.',
  habitacion: 'Los huéspedes tienen su propia habitación en un alojamiento, incluyendo acceso a espacios compartidos como cocina, baños u otros.',
  compartida: 'Los huéspedes duermen en una habitación compartida en un hostal o establecimiento administrado por profesionales y con personal 24/7.',
  acampar: 'Vive la aventura al aire libre.',
};

function getRoomDescription(label, desc) {
  if (desc && desc.trim()) {
    return desc;
  }
  const l = (label || '').toLowerCase();
  if (l.includes('entero') || l.includes('entire') || l.includes('completo')) {
    return FALLBACK_DESCRIPTIONS.entero;
  }
  if (l.includes('compartida') || l.includes('shared')) {
    return FALLBACK_DESCRIPTIONS.compartida;
  }
  if (l.includes('acampar') || l.includes('camp')) {
    return FALLBACK_DESCRIPTIONS.acampar;
  }
  return FALLBACK_DESCRIPTIONS.habitacion;
}

function getRoomOrder(label) {
  const l = (label || '').toLowerCase();
  if (l.includes('entero') || l.includes('entire') || l.includes('completo')) return 1;
  if (l.includes('compartida') || l.includes('shared')) return 3;
  if (l.includes('acampar') || l.includes('camp')) return 4;
  return 2;
}

class Page2B extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    previousPage: PropTypes.any,
    nextPage: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = {
      isDisabled: true,
      roomType: [],
    }
  }

  UNSAFE_componentWillMount() {
    const { listingFields } = this.props;
    if (listingFields != undefined) {
      this.setState({ roomType: listingFields.roomType });
    }
  }

  componentDidMount() {
    const { valid } = this.props;
    this.setState({ isDisabled: !valid });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { valid, listingFields } = nextProps;
    this.setState({ isDisabled: !valid });
    if (listingFields != undefined) {
      this.setState({ roomType: listingFields.roomType });
    }
  }

  renderIcon = (item) => {
    if (item.image != null && item.image !== undefined && item.image !== '') {
      return (
        <img
          src={url + '/images/amenities/' + item.image}
          width="26"
          height="26"
          alt={item.label || ''}
        />
      );
    }
    return (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#003453" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 10.5L12 3l9 7.5v9.5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-9.5z" />
        <path d="M9 22v-6a3 3 0 0 1 6 0v6" />
      </svg>
    );
  };

  renderRoomTypeCard = ({ input, options, meta: { touched, error } }) => {
    const { formatMessage } = this.props.intl;
    return (
      <FormGroup>
        <div className={s.roomTypeGrid}>
          {options?.map((item) => {
            const isActive = input.value == item.value;
            return (
              <div
                key={item.value}
                className={cx(s.roomTypeOption, { [s.roomTypeOptionActive]: isActive })}
                onClick={() => input.onChange(item.value)}
              >
                <div className={s.roomTypeCardTop}>
                  <div className={s.roomTypeIconCircle}>
                    {this.renderIcon(item)}
                  </div>
                  <div className={s.roomTypeRadioWrapper}>
                    {isActive ? (
                      <span className={s.roomTypeRadioChecked}>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                          <path d="M2.5 6.2L4.8 8.5L9.5 3.5" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </span>
                    ) : (
                      <span className={s.roomTypeRadioUnchecked} />
                    )}
                  </div>
                </div>
                <div className={s.roomTypeCardContent}>
                  <h3 className={cx(s.roomTypeCardTitle, { [s.roomTypeCardTitleActive]: isActive })}>
                    {item.label}
                  </h3>
                  {item.description && (
                    <p className={cx(s.roomTypeCardDesc, { [s.roomTypeCardDescActive]: isActive })}>
                      {item.description}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </FormGroup>
    );
  };

  render() {
    const { handleSubmit, previousPage, nextPage, existingList, formPage, step } = this.props;
    const { formatMessage } = this.props.intl;
    const { isDisabled, roomType } = this.state;
    let path = "room";
    /* if (existingList) {
      path = "home";
    } */

    let roomTypeValue = [];
    roomType && roomType.forEach((item) => {
      if (item.isEnable == 1) {
        roomTypeValue.push({
          value: item.id,
          label: item.itemName,
          description: getRoomDescription(item.itemName, item.itemDescription),
          order: getRoomOrder(item.itemName),
          image: item.image,
        });
      }
    });

    roomTypeValue.sort((a, b) => a.order - b.order);

    return (
      <div className={s.eslipinBg}>
        <div className={s.grid}>
          <SidePanel
            badge="Información del alojamiento"
            mainTitle={
              <>
                ¿De qué <span className={s.sidePanelHighlight}>tipo de alojamiento</span>{'\n'}
                dispondrán los huéspedes?
              </>
            }
            subtitle="Selecciona la opción que mejor describa tu propiedad. Esto nos ayuda a mostrar tu alojamiento a las personas adecuadas."
            iconImg={stepTwoIllustration}
            step={step || 1}
            formPage={formPage || "room-type"}
          />
          <div>
            <form onSubmit={handleSubmit}>
              <div className={s.stepRightCard}>
                <div className={s.landingMainContent}>
                  <Field
                    name="roomType"
                    component={this.renderRoomTypeCard}
                    options={roomTypeValue}
                  />
                </div>
                <FooterButton
                  isDisabled={isDisabled}
                  nextPage={nextPage}
                  previousPage={previousPage}
                  nextPagePath={"bedrooms"}
                  previousPagePath={path}
                  formPage={formPage}
                  step={step}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

Page2B = reduxForm({
  form: 'ListPlaceStep1',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
  onSubmit: update,
})(Page2B);

const selector = formValueSelector('ListPlaceStep1');

const mapState = (state) => ({
  existingList: state.location.isExistingList,
  listingFields: state.listingFields.data,
});

const mapDispatch = {};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(Page2B)));
